import { Form, SubmitButton } from '@panwds/react-form-legacy'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from '@panwds/react-ui'
import { toString } from 'lodash'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { ClaimLicenses, CreateRootTSG, LoadTreeDataAsync } from '../../../common/actions/GlobalActions'
import ScreenLoader from '../../../common/components/screenLoader/ScreenLoader'
import ZIndex from '../../../common/components/zIndex/ZIndex'
import { VIEW_MANAGE_TENANT } from '../../../common/constants/GlobalConstants'
import { setNewTsgLoading } from '../../../common/reducers/actions/LicenseReducer.actions'
import { selectTreeNode } from '../../../common/reducers/actions/TreeReducer.actions'
import { setCurrentViewing } from '../../../common/utils/Sparky'
import { calculateNewTsg } from '../../util/common'
import {
  ADD_NEW,
  CANCEL_BUTTON, CLAIM_ERROR_TSG_MSG,
  CLAIM_SUBSCRIPTION_BUTTON_TEXT, SUCCESS_MESSAGE,
} from '../constants/SubscriptionConstant'
import TenantSelection from '../tenantSelection/TenantSelection'
import WorkFlow from '../workFlow/WorkFlow'

/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on ClaimSubscriptionModal.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */


const ClaimSubscriptionModal = (props) => {
  const { closeModal, isOpen, title, content, handleSubmit, setShowErrorMsg,
    cspDropDownData, row, globalTsgId, dispatch, globalDispatch, ...rest } = props
  const [lockedTsg, setLockedTsg] = useState()
  const [isFormLoading, setFormLoading] = useState(false)
  const [isDayZero] = useState(rest.tsgDropDownDetails.length === 0)
  const [disabled, setDisabled] = useState(true)
  const handleResponse = useCallback((isError, submitMessage) => {
    isError && setShowErrorMsg(submitMessage)
    handleSubmit(submitMessage, isError)
    closeModal()
    setFormLoading(false)
  }, [closeModal, handleSubmit, setShowErrorMsg])

  useEffect(() => {
    if (row?.original?.locked_tsg?.length) {
      setLockedTsg(row?.original?.locked_tsg)
    }
  }, [row?.original?.locked_tsg])
  const handleDispatch = useCallback((tsgNode, tsg_id) => {
    if (!rest.newTsgLoading?.dayZero) {
      setCurrentViewing(VIEW_MANAGE_TENANT)
    }
    dispatch(selectTreeNode(tsgNode))
  }, [dispatch, rest.newTsgLoading?.dayZero])

  const onSubmit = useCallback(async (values) => {
    setFormLoading(true)
    const tsgDetails = {
      tsg_name: values['tsgId'].description,
      tsg_id: values['tsgId'].key,
      claimLicense: true
    }
    let tsgResponse = {}
    if (values['tsgId'].key === ADD_NEW) {
      const newTsgName = calculateNewTsg(values['tsgId'].desc, values['tsgId'].desc, rest.tsgDropDownDetails)
      rest.licenseDispatch(setNewTsgLoading({ newTsg: true, dayZero: isDayZero }))
      await CreateRootTSG({ display_name: newTsgName }).then((data) => {
        tsgResponse = { ...data }
        rest.licenseDispatch(setNewTsgLoading({ newTsg: false, dayZero: false }))
      }).catch((err) => {
        tsgDetails.claimLicense = false
        rest.licenseDispatch(setNewTsgLoading({ newTsg: false, dayZero: false }))
        handleResponse(true, CLAIM_ERROR_TSG_MSG)
      })
    }
    if (values['tsgId'].key === ADD_NEW && tsgDetails.claimLicense) {
      await LoadTreeDataAsync(dispatch)
      tsgDetails.tsg_id = tsgResponse.id
      tsgDetails.tsg_name = tsgResponse.display_name
    }
    const response = {
      tsg_name: tsgDetails.tsg_name,
      hash: row.original.hash,
      support_account_id: toString(values['cspAccount'].id),
      support_account_name: values['cspAccount'].description
    }
    if (tsgDetails.claimLicense) {
      ClaimLicenses(response, tsgDetails.tsg_id).then(async (data) => {
        // wait for UI to obtain newly created tsg

        await globalDispatch.switchTsg(tsgDetails.tsg_id, { forceReload: false })
        if (values['tsgId'].key === ADD_NEW) {
          handleDispatch(tsgResponse)
          handleResponse(false, SUCCESS_MESSAGE.replace('$', tsgDetails.tsg_name))
        }
        else {
          handleDispatch(rest.sgKeyBy[tsgDetails.tsg_id], tsgDetails.tsg_id)
          handleResponse(false, SUCCESS_MESSAGE.replace('$', tsgDetails.tsg_name))
        }
      }, (err) => {
        rest.licenseDispatch(setNewTsgLoading({ newTsg: false, dayZero: false }))
        handleResponse(true, err.message)
      })
    }
  }, [row.original.hash, globalTsgId, rest, isDayZero, dispatch, handleDispatch, handleResponse, globalDispatch])

  const getClaimsContent = useMemo(() => {
    return <>
      <div className={'tw-flex tw-flex-col tw-p-0 tw-m-0'}>
        <WorkFlow showWorkFlow={true}/>
        <div>
          <TenantSelection lockedTsg={lockedTsg} showCspDropDown={true} cspDropDownData={cspDropDownData.sort((a, b) => {
            if (a.description < b.description) {
              return -1
            }
            if (a.description > b.description) {
              return 1
            }
            return 0
          })} {...{ ...rest, row, setDisabled }} />
        </div>
      </div>
    </>
  }, [cspDropDownData, lockedTsg, rest, row])

  return <ZIndex>
    <Modal style={{ top: '12%', height: '498px', width: '390px' }}
      onClose={closeModal}
      isOpen={isOpen}
      confirmClose={false}
    >
      {isFormLoading && <ScreenLoader/>}
      <Form style={{ width: '50%' }} mode='onBlur' onSubmit={onSubmit} formProps={{ autoComplete: 'off' }} >
        <ModalHeader title={title} />
        <ModalBody addClassName='tw-mb-12' style={{ padding: '0px' }} >
          {getClaimsContent}
        </ModalBody>
        <ModalFooter addClassName='tw-mt-4'>
          <Button addClassName='tw-mt-2' onClick={closeModal} >
            {CANCEL_BUTTON}
          </Button>
          <SubmitButton
            addClassName='tw-mt-2'
            appearance={'primary'}
            disabled={disabled}
            type={'submit'}>
            {CLAIM_SUBSCRIPTION_BUTTON_TEXT}
          </SubmitButton>
        </ModalFooter>
      </Form>
    </Modal>
  </ZIndex>
}

export default ClaimSubscriptionModal
